/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Try_For_FreeInputs */

const en_common_try_for_free = /** @type {(inputs: Common_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try for free`)
};

const es_common_try_for_free = /** @type {(inputs: Common_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba gratis`)
};

/**
* | output |
* | --- |
* | "Try for free" |
*
* @param {Common_Try_For_FreeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_try_for_free = /** @type {((inputs?: Common_Try_For_FreeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Try_For_FreeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_try_for_free(inputs)
	return en_common_try_for_free(inputs)
});